var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from "@angular/core";
import { FormControl, FormGroup, FormBuilder, Validators } from "@angular/forms";
import { BusinesLogicService } from "../../services/business-logic.service";
import { DataService } from "../../services/data.service";
import { LanguageService } from "../../services/language.service";
import { NotificationService } from "../../services/notification.service";
import { Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ModalHelper } from "../../components/modal/modal.helper";
import { LanguagePipe } from "../../services/language.pipe";
import { takeUntil } from "rxjs/operators";
import { BusinessEventService } from "../../services/business-event.service";
var LoginComponent = (function () {
    function LoginComponent(_lf, _blogic, _data, _language, _notify, _modal, _lang, _http, _bevent) {
        this._lf = _lf;
        this._blogic = _blogic;
        this._data = _data;
        this._language = _language;
        this._notify = _notify;
        this._modal = _modal;
        this._lang = _lang;
        this._http = _http;
        this._bevent = _bevent;
        this.logged = new EventEmitter();
        this.visible = true;
        this.deskprofileError = false;
        this.autoLogin = false;
        this.numLoaded = 0;
        this.desk = null;
        this.showSelectOffice = true;
        this.office = null;
        this.officename = "";
        this.token = null;
        this.config = null;
        this.loadingSocket = false;
        this.repeatPasswordAlert = false;
        this.repeatPasswordAlertText = "";
        this.repeatPasswordAlertClass = "alert-success";
        this.lastCredentials = {};
        this.onlineDeskName = "";
        this.onlineOfficeName = "";
        this.onlineDeskIP = "";
        this.disconectSessionConfirm = false;
        this.destroy$ = new Subject();
        this._getOffices();
        if (this._data.isLogged()) {
            this.autoLogin = true;
        }
        var lang = navigator.language;
        if (lang.length > 2) {
            lang = lang.split("-");
            lang = lang[1];
        }
        this._language.exist(lang.toUpperCase());
        var desk = localStorage.getItem("desk");
        var office = localStorage.getItem("office");
        if (desk != null) {
            this.desk = JSON.parse(desk);
            var coffice = JSON.parse(office);
            if (coffice != null) {
                this.office = parseInt(coffice["id"]);
                this.officename = coffice["name"];
            }
        }
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.visible) {
            this.loadFormInputs();
            this.getJSON()
                .pipe(takeUntil(this.destroy$))
                .subscribe(function (data) {
                _this.config = data;
                _this._data.json_config = data;
                if (data.autologin && data.autologin.active) {
                    var credentials = {
                        username: data.autologin.username,
                        pwd: data.autologin.password,
                        desk_id: parseInt(data.autologin.desk_id.toString()),
                    };
                    _this.office = data.autologin.office_id;
                    _this.doLogin(credentials);
                }
                else {
                    if (_this._data.isLogged()) {
                        var credentials = _this._data.getStoredCredentials();
                        _this.doLogin(credentials);
                    }
                }
                if (_this.office) {
                    _this._getDesks(_this.office, false);
                }
                if (_this.config.autoreset) {
                    localStorage.removeItem("office");
                    localStorage.removeItem("desk");
                    _this.desk = null;
                    _this.loadFormInputs();
                }
            });
        }
        this._blogic.loginError$
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            if (response != false) {
                _this.errorStatus = response["status"];
                _this.autoLogin = false;
                _this.hasError = true;
                _this.deskprofileError = false;
                _this._data.deleteStoredCredentials();
            }
        });
        this.initChangePasswordForm();
    };
    LoginComponent.prototype._findGetParameter = function (parameterName) {
        var result = null, tmp = [];
        var items = location.search.substr(1).split("&");
        for (var index = 0; index < items.length; index++) {
            tmp = items[index].split("=");
            if (tmp[0] === parameterName)
                result = decodeURIComponent(tmp[1]);
        }
        return result;
    };
    LoginComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    LoginComponent.prototype.initChangePasswordForm = function () {
        this.changePasswordForm = new FormGroup({
            user: new FormControl("", [Validators.required]),
            lastPassword: new FormControl(""),
            newPassword: new FormControl("", [Validators.required]),
            repeatNewPassword: new FormControl("", [Validators.required]),
        });
    };
    LoginComponent.prototype.loadFormInputs = function () {
        if (localStorage.getItem("desk") == null) {
            this.loginForm = this._lf.group({
                desk: ["", Validators.required],
                user: ["", Validators.required],
                password: [""],
            });
        }
        else {
            this.loginForm = this._lf.group({
                user: ["", Validators.required],
                password: [""],
            });
        }
    };
    LoginComponent.prototype.getJSON = function () {
        return this._http.get("./assets/config.json");
    };
    /* Action of submit button */
    LoginComponent.prototype.onSubmit = function () {
        switch (this.loginForm.get("user").value) {
            case "resetall":
                this.removeOffice();
                break;
            case "reset":
                this.removeDesk();
                break;
            default:
                if (this.loginForm.get("user").value == "reset") {
                    this.removeOffice();
                }
                else {
                    var desk = void 0;
                    if (localStorage.getItem("desk") == null) {
                        desk = this.loginForm.get("desk").value;
                    }
                    else {
                        desk = JSON.parse(localStorage.getItem("desk")).id;
                    }
                    var user = this.loginForm.get("user").value;
                    var password = this.loginForm.get("password").value;
                    var credentials = {
                        username: user,
                        pwd: password,
                        desk_id: parseInt(desk),
                    };
                    this.doLogin(credentials);
                }
                break;
        }
    };
    LoginComponent.prototype.isLoginAvailable = function (credentials) {
        var _this = this;
        return new Promise(function (resolve) {
            var params = {
                desk_id: credentials["desk_id"],
            };
            _this._blogic
                .checkDeskOnline(params)
                .pipe(takeUntil(_this.destroy$))
                .subscribe(function (response) {
                resolve(response);
            });
        });
    };
    /* Do login with credentials object */
    LoginComponent.prototype.doLogin = function (credentials, withOnlineFilter, link) {
        if (withOnlineFilter === void 0) { withOnlineFilter = true; }
        if (link === void 0) { link = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var deskStatus, isDeskOnline;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!withOnlineFilter) return [3 /*break*/, 2];
                        deskStatus = {};
                        return [4 /*yield*/, this.isLoginAvailable(credentials).then(function (value) {
                                deskStatus = value;
                            })];
                    case 1:
                        _a.sent();
                        isDeskOnline = deskStatus["hostaddr"] == null ? false : true;
                        if (isDeskOnline === true) {
                            this.lastCredentials = credentials;
                            this.onlineDeskName = deskStatus["desk_name"];
                            this.onlineOfficeName = deskStatus["office"];
                            this.onlineDeskIP = deskStatus["hostaddr"];
                            this.showDeskInUse();
                            return [2 /*return*/, false];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this._modal.hide("deskInUseModal");
                        _a.label = 3;
                    case 3:
                        this._blogic
                            .token(credentials)
                            .pipe(takeUntil(this.destroy$))
                            .subscribe(function (response1) {
                            _this.token = response1.access_token;
                            _this._data.token = _this.token;
                            _this.deskprofileError = false;
                            _this._blogic
                                .login(credentials)
                                .pipe(takeUntil(_this.destroy$))
                                .subscribe(function (response2) {
                                if (response2 == null) {
                                    _this.deskprofileError = true;
                                    _this.hasError = false;
                                }
                                else {
                                    _this.deskprofileError = false;
                                }
                                var desk = credentials["desk_id"];
                                var user = credentials["username"];
                                _this._data.session = response2;
                                var deskSaved = JSON.parse(localStorage.getItem("desk"));
                                var officeSaved = JSON.parse(localStorage.getItem("office"));
                                var deskData = _this._getDeskById(_this._data.desks, desk);
                                if (!withOnlineFilter) {
                                    window.location.reload();
                                }
                                if (deskData == null || typeof deskData == "undefined") {
                                    setTimeout(function () {
                                        _this.doLogin(credentials, withOnlineFilter, link);
                                    }, 500);
                                    return;
                                }
                                if (deskSaved == null) {
                                    _this._data.session["desk"] = desk;
                                    var coffice = _this._getOfficeById(_this.offices, _this.office);
                                    _this._data.session["deskname"] = deskData.title;
                                    _this._data.session["office"] = _this.office;
                                    _this._data.session["officename"] = coffice.name;
                                }
                                else {
                                    _this._data.session["desk"] = deskSaved.id;
                                    _this._data.session["deskname"] = deskSaved.name;
                                    _this._data.session["qdesk_id"] = deskSaved.qdesk_id;
                                    _this._data.session["office"] = officeSaved.id;
                                    _this._data.session["officename"] = officeSaved.name;
                                }
                                var deskObj = {
                                    id: _this._data.session["desk"],
                                    name: _this._data.session["deskname"],
                                };
                                var officeObj = {
                                    id: _this._data.session["office"],
                                    name: _this._data.session["officename"],
                                };
                                _this._data.session["qdesk_id"] = deskData.qdesk_id;
                                localStorage.setItem("desk", JSON.stringify(deskObj));
                                localStorage.setItem("office", JSON.stringify(officeObj));
                                _this._data.session["operator"] = user;
                                _this._getOfficeConfiguration();
                                _this._notify.getPermissions();
                                _this._getDeskStatus();
                                _this._getAtypes();
                                if (_this._data.session["deskconfig"] != null) {
                                    _this._data.configuration = JSON.parse(_this._data.session["deskconfig"]);
                                    _this._language.exist(_this._data.configuration["language"]);
                                }
                                _this._getSessionId(_this._data.session["desk"]);
                                // Initialize socket
                                _this.InitSocketCom();
                                _this._data.storeCredentials(credentials);
                                _this.hasError = false;
                                if (link) {
                                    window.location.reload();
                                }
                            }, function (err) {
                                console.log("Entro en error");
                                console.log(err);
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype._getOfficeConfiguration = function () {
        var _this = this;
        this._blogic.configDesk()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.dniTranslation = (response.translations_dni && response.translations_dni.length > 0) ? response.translations_dni : "DNI del cliente";
            _this._data.ccodeTranslation = (response.translations_ccode && response.translations_ccode.length > 0) ? response.translations_ccode : "Código del cliente";
        });
    };
    LoginComponent.prototype.showDeskInUse = function () {
        this.disconectSessionConfirm = false;
        this._modal.show("deskInUseModal");
        var self = this;
        $("#deskInUseModal").on("hidden.bs.modal", function (e) {
            self.resetLogin();
        });
    };
    LoginComponent.prototype.resetLogin = function () {
        this._modal.hide("deskInUseModal");
        this.autoLogin = false;
        this.hasError = true;
        this.deskprofileError = false;
        this._data.deleteStoredCredentials();
        localStorage.removeItem("office");
        localStorage.removeItem("desk");
        this.desk = null;
        this.loadFormInputs();
    };
    LoginComponent.prototype.InitSocketCom = function () {
        var _this = this;
        if (!this.loadingSocket) {
            this.loadingSocket = true;
            if (this.subscriptionClose != null)
                this.subscriptionClose.unsubscribe();
            if (this.subscriptionOpen != null)
                this.subscriptionOpen.unsubscribe();
            this._bevent.close();
            this._bevent.open();
            this.subscriptionOpen = this._bevent
                .onOpen()
                .subscribe(function (response) {
                _this.loadingSocket = false;
            });
            this.subscriptionClose = this._bevent
                .onClose()
                .subscribe(function (response) {
                _this._bevent.close();
                _this.InitSocketCom();
                _this.loadingSocket = false;
            });
        }
    };
    /* Get the actual session id */
    LoginComponent.prototype._getSessionId = function (desk) {
        var _this = this;
        var params = {
            op: "status",
            desk_id: desk,
        };
        this._blogic
            .getSession()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.session["session"] = response[0]["id"];
            _this._sumLogged();
        });
    };
    /* Get the offices list */
    LoginComponent.prototype._getOffices = function () {
        var _this = this;
        this._blogic
            .getOffices()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.offices = response;
            _this._data.offices = response;
        });
    };
    /* Get Office from list of desk using id */
    LoginComponent.prototype._getOfficeById = function (data, office_id) {
        for (var i = 0; i < data.length; i++) {
            if (data[i].id == office_id)
                return data[i];
        }
    };
    /* Get the office's desk list*/
    LoginComponent.prototype._getDesks = function (id, setvalue) {
        var _this = this;
        if (setvalue === void 0) { setvalue = true; }
        this._blogic
            .listDesk({ office_id: this.office })
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this.desks = response.filter(function (e) { return e.visible == true; });
            if (response.length != 0 && setvalue)
                _this.loginForm.controls["desk"].setValue(_this.desks[0]["id"]);
            _this._data.desks = _this.desks;
        });
    };
    /* Get the actual desk status */
    LoginComponent.prototype._getDeskStatus = function () {
        var _this = this;
        var params = {
            desk_id: this._data.session["desk"],
            status: "query",
        };
        this._blogic
            .deskNotify(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            var turn = response;
            if (turn["id"] != -1) {
                _this._data.turn = turn;
            }
            _this._sumLogged();
        });
    };
    /* Get Desk from list of desk using id */
    LoginComponent.prototype._getDeskById = function (data, desk_id) {
        for (var i = 0; i < data.length; i++) {
            if (data[i].id == desk_id)
                return data[i];
        }
    };
    /* Parse desk list using the desk id as key of array */
    LoginComponent.prototype._parseDesk = function (data) {
        var parseArray = [];
        for (var i = 0; i < data.details.length; i++) {
            parseArray[data.details[i].id - 1] = data.details[i];
        }
        return parseArray;
    };
    /* Get the desk list */
    LoginComponent.prototype._getAtypes = function () {
        var _this = this;
        this._blogic
            .kindListOffice()
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.session["atypes"] = _this._parseAtypes(response);
            _this._sumLogged();
        });
    };
    /* Parse atype list using the desk id as key of array */
    LoginComponent.prototype._parseAtypes = function (data) {
        this._data.session["allTypes"] = data;
        var filterArray = [];
        if (this._data.session["changekind"].length != 0) {
            var availableAtypes = this._data.session["changekind"].split(",");
            for (var i = 0; i < data.length; i++) {
                if (availableAtypes.indexOf(data[i].id.toString()) != -1) {
                    filterArray.push(data[i]);
                }
            }
            return filterArray;
        }
        return data;
    };
    LoginComponent.prototype._sumLogged = function () {
        this.numLoaded = this.numLoaded + 1;
        /* No turn */
        if (this.numLoaded == 3) {
            this.autoLogin = true;
            this.logged.emit(this.autoLogin);
            this._data.session["desks"] = this.desks;
        }
    };
    LoginComponent.prototype.removeOffice = function () {
        localStorage.removeItem("office");
        localStorage.removeItem("desk");
        this.desk = null;
        this.showSelectOffice = true;
        this.ngOnInit();
    };
    LoginComponent.prototype.removeDesk = function () {
        localStorage.removeItem("desk");
        this.desk = null;
        if (localStorage.getItem("office") != null)
            this.showSelectOffice = false;
        this.ngOnInit();
    };
    LoginComponent.prototype.changeOffice = function () {
        this._getDesks(this.office);
    };
    LoginComponent.prototype.openChangePasswordModal = function () {
        this.initChangePasswordForm();
        this.repeatPasswordAlert = false;
        this._modal.show("changePasswordModal");
    };
    LoginComponent.prototype.showAlert = function (cssClass, text) {
        this.repeatPasswordAlertClass = cssClass;
        this.repeatPasswordAlertText = text;
        this.repeatPasswordAlert = true;
    };
    LoginComponent.prototype.changePassword = function () {
        var _this = this;
        if (this.changePasswordForm.get("newPassword").value !=
            this.changePasswordForm.get("repeatNewPassword").value) {
            this.showAlert("alert alert-danger", this._lang.transform("passwordNotMatch"));
            this.changePasswordForm.controls["repeatNewPassword"].setErrors({
                incorrect: true,
            });
        }
        else {
            var params = {
                login: this.changePasswordForm.get("user").value,
                oldpwd: this.changePasswordForm.get("lastPassword").value,
                newpwd: this.changePasswordForm.get("newPassword").value,
            };
            this._blogic
                .changePassword(params)
                .pipe(takeUntil(this.destroy$))
                .subscribe(function (response) {
                _this.showAlert("alert alert-success", _this._lang.transform("passwordSuccess"));
                setTimeout(function () {
                    _this._modal.hide("changePasswordModal");
                }, 1500);
            }, function (error) {
                _this.showAlert("alert alert-danger", _this._lang.transform("invalidUserPassword"));
                _this.changePasswordForm.controls["user"].setErrors({
                    incorrect: true,
                });
                _this.changePasswordForm.controls["lastPassword"].setErrors({
                    incorrect: true,
                });
            });
        }
    };
    return LoginComponent;
}());
export { LoginComponent };
